import { useEffect, useState } from 'react';
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
// import { getStorage, ref, listAll } from "firebase/storage";
// import firebase from 'firebase/app';
// import 'firebase/storage';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Firebase configuration now sourced from environment variables (.env.local)
// Create React App exposes variables prefixed with REACT_APP_
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);


export const useFirebaseStorageList = (path) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const storage = getStorage();
        const listRef = ref(storage, path);

        listAll(listRef)
            .then(async (res) => {
                const folders = res.prefixes.map(folderRef => folderRef.name);
                const files = [];
                for (const itemRef of res.items) {
                    const downloadURL = await getDownloadURL(itemRef);
                    files.push({ name: itemRef.name, downloadURL });
                }
                // console.log(files)
                setItems({ folders, files });
                setLoading(false);
            })
            .catch((error) => {
                setError(error);
                setLoading(false);
            });
    }, [path]);

    return { items, loading, error };
};

// export default useFirebaseStorageList;